import type { FunctionComponent } from 'react'

import { FlowPage } from '@monthio/design-system'
import { FinalFlowImage } from '#modules/FlowCompleted/Components/FinalFlowImage'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AuthenticationErrorCode } from '../types/authenticationErrorCode'

const IconWrapper = styled.div`
	text-align: center;
`

interface UnauthorizedPageProps {
	errorCode?: string
	children?: never
}

export const UnauthorizedPage: FunctionComponent<UnauthorizedPageProps> = ({
	errorCode,
}) => {
	const { t } = useTranslation()

	if (
		!errorCode ||
		!Object.values<string>(AuthenticationErrorCode).includes(errorCode)
	) {
		return (
			<FlowPage>
				<FlowPage.Content $isCentered>
					<FlowPage.Header title={t('unauthorizedError-unknownError-title')} />
				</FlowPage.Content>
			</FlowPage>
		)
	}

	return (
		<FlowPage>
			<FlowPage.Content $isCentered>
				<IconWrapper>
					<FinalFlowImage />
				</IconWrapper>
				<FlowPage.Header
					title={t('unauthorizedError-sessionFinished-title')}
					description={t(`unauthorizedError-${errorCode}-text`)}
				/>
			</FlowPage.Content>
		</FlowPage>
	)
}
